import {ModuleWithProviders, NgModule, Optional, SkipSelf} from '@angular/core';
import {CommonModule} from '@angular/common';

import {AppConfig, ConfigService} from './config.service';

import {ButtonModule} from './modules/button/index';
import {CameraModule} from './modules/camera/index';
import {CardModule} from './modules/card/index';
import {ContainerModule} from './modules/container/index';
import {DialogModule, DialogService} from './modules/dialog/index';
import {DragAndDropModule} from './modules/drag-and-drop/index';
import {DrawerModule} from './modules/drawer/index';
import {DropdownModule} from './modules/dropdown/index';
import {FormModule} from './modules/form/index';
import {GenericModule} from './modules/generic/index';
import {GridModule} from './modules/grid/index';
import {IconModule} from './modules/icon/index';
import {ImageModule} from './modules/image/index';
import {LayoutModule} from './modules/layout/index';
import {ListModule} from './modules/list/index';
import {LoadingModule} from './modules/loading/index';
import {MediaModule} from './modules/media/index';
import {NoDataModule} from './modules/no-data/index';
import {PopoverModule} from './modules/popover/index';
import {PrintModule} from './modules/print/index';
import {QRScannerModule} from './modules/qr-scanner/index';
import {TableModule} from './modules/table/index';
import {TabsModule} from './modules/tabs/index';
import {TemplateModule} from './modules/template/index';
import {ToastModule} from './modules/toast/index';
import {TranslateModule} from './modules/translate/index';
import {TryAgainModule} from './modules/try-again/index';

const Modules = [
  ButtonModule,
  CameraModule,
  CardModule,
  ContainerModule,
  DialogModule,
  DragAndDropModule,
  DrawerModule,
  DropdownModule,
  FormModule,
  GenericModule,
  GridModule,
  IconModule,
  ImageModule,
  LayoutModule,
  ListModule,
  LoadingModule,
  MediaModule,
  NoDataModule,
  PopoverModule,
  PrintModule,
  QRScannerModule,
  TableModule,
  TabsModule,
  TemplateModule,
  ToastModule,
  TranslateModule,
  TryAgainModule
];

@NgModule({
  imports: [CommonModule, Modules],
  exports: [Modules],
  providers: [ConfigService]
})
export class ExtensionModule {
  constructor(@Optional() @SkipSelf() parentModule: ExtensionModule) {
    if (parentModule) {
      throw new Error('ExtensionModule has already been imported.');
    }
  }

  static forRoot(config?: AppConfig): ModuleWithProviders {
    return {
      ngModule: ExtensionModule,
      providers: [
        DialogService,
        {
          provide: AppConfig,
          useValue: config ? config : {}
        }
      ]
    };
  }
}
